import { render, staticRenderFns } from "./OrderActionButtons.vue?vue&type=template&id=01a9bc5e"
import script from "./OrderActionButtons.vue?vue&type=script&lang=js"
export * from "./OrderActionButtons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports